// extracted by mini-css-extract-plugin
export default {"showingResultsForRenderer":"showingResultsForRenderer_showingResultsForRenderer__CkVSa"};